import { apiBackOffice, apiSimulacao } from './utils/api';
import { dateToCustomString } from './utils/formatDateHourBR';

export const getClusters = async () => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Cluster/`).then((response) => response.data);
  return res;
}

export const getClientes = async (skip, take) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Cliente/`, { params: { take: take, skip: skip } }).then((response) => response.data);
  return res;
}

export const getTrilhas = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Trilha/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const getPrazosPagamento = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PrazoPagamento/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getTipoCondicoes = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/TipoCondicao/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getGruposCentralizadores = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/GrupoCentralizador/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getGrupoSegmentos = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/GrupoSegmento/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getGrupoSegmentosPorTrilha = async (trilha) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/GrupoSegmento/PorTrilha/` + trilha).then((response) => response.data);
  return res;
}

export const getSegmentos = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Segmento/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getSegmentosPorGrupoSegmento = async (grupoSegmento) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Segmento/PorGrupoSegmento/` + grupoSegmento).then((response) => response.data);
  return res;
}

export const getCidades = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Cidade/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getCidadesPorEstado = async (estado) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Cidade/Estado/` + estado).then((response) => response.data);
  return res;
}

export const getEstados = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Estado/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getFiliais = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Filial/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getProdutos = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Produto/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPrecoRegra = async (produtoId, filialId, microrregiaoId) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Produto/${produtoId}/${filialId}/${microrregiaoId}`).then((response) => response.data);
  return res;
}

export const getListaPrecoRegra = async (produtosIds, microrregiaoId) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.post(`/api/Produto/Preco/ProdutoArray`, { produtosIds, microrregiaoId }).then((response) => response.data);
  return res;
}

export const getServicosPreco = async (idProduto, idCliente) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Servico/${idProduto}/${idCliente}`).then((response) => response.data);
  return res;
}

export const getServicos = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiSimulacao.get(`/api/TabelaPreco/Servicos`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getProdutoFilialMicro = async (id) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/ProdutoFilial/Microrregiao/${id}`).then((response) => response.data);
  return res;
}

export const getPrecoProdutoFilialCliente = async (clienteId, produtoFilialId) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PrecoCliente/${clienteId}/${produtoFilialId}`).then((response) => response.data);
  return res;
}

export const getGrupoProdutos = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/GrupoMaterial/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const getSubGrupoProdutos = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/SubGrupoMaterial/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const getFamiliaProdutos = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/FamiliaMaterial/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getEmbalagem = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Embalagem/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getUnidadeMedida = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/UnidadeMedida/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const getMotivos = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Motivo/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getEmpresa = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Empresa/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getProdutosFiliais = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/ProdutoFilial/Vendedor`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getParametros = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Parametro/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const getContextos = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Contexto/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getLocais = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/Local/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const salvarLog = async (campos, url, status, response, stack) => {
  const responseLog = await apiBackOffice.post(`/api/LogErro`, {
    url: url || 'sem url',
    metodo: 'POST',
    payload: JSON.stringify(campos),
    status: `${status || 'sem status'}`,
    resposta: response || 'sem resposta',
    stack: stack || 'sem stack',
  });
  return responseLog;
}


export const getCanaisDistribuicao = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/CanalDistribuicao/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


//MAPA DA MINA
export const getPesquisaUnidadeMedida = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaUnidadeMedida/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}



export const getPesquisaPrazo = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaPrazo/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaEmbalagem = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaEmbalagem/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaCanalDistribuicao = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaCanalDistribuicao/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaPlayer = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaPlayer/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaProduto = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaProduto/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaGrupoMaterial = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaGrupoMaterial/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaGrupoMaterialCanalDistribuicao = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaGrupoMaterialCanalDistribuicao/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaGrupoMaterialEmbalagem = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaGrupoMaterialEmbalagem/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaGrupoMaterialPlayer = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaGrupoMaterialPlayer/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaGrupoMaterialUnidadeMedida = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaGrupoMaterialUnidadeMedida/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const getPesquisaGrupoMaterialPrazo = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`/api/PesquisaGrupoMaterialPrazo/`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}

export const setLogAcesso = async ({ location, pagina, dispositivo }) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.post(`/api/LogAcesso/RegistraLog`, {
    ...location,
    origem: "HUB VenD+",
    latitude: location.latitude?.toString() ?? null,
    longitude: location.longitude?.toString() ?? null,
    precisao: location.precisaoMetros?.toString() ?? null,
    pagina,
    dispositivo,
    createdAt: dateToCustomString(new Date()) ?? null
  }).then((response) => response.data);
  return res;
}

export const registraSincronizacao = async (inicioFim) => {
  if (!navigator.onLine) {
    return null;
  }

  const res = await apiBackOffice
    .get(`/api/LogAcesso/RegistraSincronizacao`, {
      params: { inicioFim }
    })
    .then((response) => response.data);

  return res;
}